import React from "react"
import { Container } from "react-bootstrap"
import parse from 'html-react-parser';
import Slider from "react-slick"
import { Link } from "@StarberryUtils"
import "./TeamSlider.scss"

const TeamSlider = ({ Title, Content, officeTeam }) => {
  if (!officeTeam || officeTeam.length === 0) return null

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1 },
      },
    ],
  }

  const normalizeUrl = (url) => {
    if (!url) return "#";
    if (url.includes("about-us/our-team")) return `/${url.replace(/^\/+/, "")}`;
    return `/about-us/our-team/${url.replace(/^\/+/, "")}`;
  };

  return (
    <section className="team-slider-section">
      <Container>
        {(Title || Content) && (
          <div className="team-slider-header">
            {Title && <h2>{Title}</h2>}
            {Content && <div className="description">{parse(Content)}</div>}
          </div>
        )}

        <Slider {...settings} className="team-slider">
          {officeTeam.map((member, index) => (
            <div className="team-slider-item" key={index}>
              <div className="team-card">
                <Link to={normalizeUrl(member?.URL)} className="team-image">
                  <img
                    src={member?.Image?.url}
                    alt={member?.Image?.alternativeText || member?.Name}
                  />
                </Link>

                <div className="team-info">
                  <Link to={normalizeUrl(member?.URL)} className="team-name">
                    {member?.Name}
                  </Link>

                  {member?.Designation && (
                    <p className="team-role">{member.Designation}</p>
                  )}

                  <div className="team-contact">
                    {member?.Phone && (
                      <a href={`tel:${member.Phone}`} className="team-phone">
                        <i className="icon-phone"></i>
                        Phone
                      </a>
                    )}

                    {member?.Email && (
                      <a
                        href={`mailto:${member.Email}`}
                        className="team-email"
                      >
                        <i className="icon-mail"></i>
                        Email
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  )
}

export default TeamSlider